module.exports = __webpack_public_path__ + "media/02_ding.db9c49a1.mp3";